export default __webpack_public_path__ + "1aea4c3c5c87c89c4030bf47af77e21d.png";